"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M4 20H20", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M5.5 16.5V13.5L16 3.5L19 6.5L8.5 16.5H5.5Z", stroke: "currentColor", strokeWidth: "1.5" })));
